/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const EmailSendModeDto = {
    New: 'NEW',
    Reply: 'REPLY',
    Forward: 'FORWARD',
    ReplyAll: 'REPLY_ALL',
} as const;

export type EmailSendModeDto = typeof EmailSendModeDto[keyof typeof EmailSendModeDto];



